/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebComponents {
    "use strict";

    export class DateInputDirectiveController {
        public static $inject: string[] = [ '$scope', '$filter', '$dealerwareInternationalizationDateFormats'];

        public label: string;
        public date: string;
        public monthYearOnly: boolean;
        public required: boolean;
        public readOnly: boolean;
        public limitDateTo: string;
        public onChange: any;
        public pattern: string = '';
        public lang: string = '';

        constructor(public $scope: any, public $filter: any, public $dealerwareInternationalizationDateFormats: any) {
            this.setInitLocale();
        }

        public setInitLocale(): void {
            this.lang = this.getCurrentLanguage();
            this.pattern = this.monthYearOnly ? this.$dealerwareInternationalizationDateFormats.formatsMonth['en'] : this.$dealerwareInternationalizationDateFormats.getFormat(this.lang);
        }

        public getCurrentLanguage(): string {
            const lng = localStorage.getItem('language');
            return (lng === this.$dealerwareInternationalizationDateFormats.FR_CA) ? this.$dealerwareInternationalizationDateFormats.FR : lng;
        }

        public get customDateString() : any {
            return this.date ? this.$filter('filterInternationalizationDate')(this.getDisplayDate(this.date)) : '';
        }

        public get dateString() : any {
            var displayDate = this.getDisplayDate(this.date);
            var validateDateDefault = this.$dealerwareInternationalizationDateFormats.dateFormatMatch(displayDate, 'en-US');
            var validateDateCurrent = this.$dealerwareInternationalizationDateFormats.dateFormatMatch(displayDate);
            if (validateDateDefault && !validateDateCurrent) {
                var formattedDate = this.date ? this.$filter('filterInternationalizationDate')(displayDate) : '';
                return this.date ? angular.copy(formattedDate) : '';
            }
            
            return this.formatByLocale(this.date);
        }

        private formatByLocale(d): string {
            
            switch(this.lang) {
                case (this.$dealerwareInternationalizationDateFormats.FR): {
                    return moment(d, this.$dealerwareInternationalizationDateFormats.formats['en']).isValid() ? moment(this.date).format(this.pattern) : this.date;
                    break;
                }
                default: return this.date;
            }
        }

        public set dateString(d: any) {
            this.onChange({ oldValue: this.date, newValue: d });

            if (d) {
                if (this.monthYearOnly) {
                    this.date = d.replace(/^(0[1-9]|1[0-2])([12][0-9]{3})$/, "$1/$2");
                    this.setValidity(this.date.match(/^(0[1-9]|1[0-2])\/([12][0-9]{3})$/) !== null);
                } else {
                    this.setValidity(this.validateDateOnChange(d, this.lang));
                }
            } else {
                this.date = undefined;
                this.$scope.dateInputForm.date.$setValidity('required', false);
                this.$scope.dateInputForm.date.$setValidity('pattern', true);
                this.$scope.dateInputForm.date.$setValidity('limit', true);
            }
        }

        public validateDateOnChange(d, lang) : boolean {
            this.date = d.replace(/^(0[1-9]|1[0-2])([0-2][0-9]|3[0-2])([12][0-9]{3})$/, "$1/$2/$3");

            var format = this.$dealerwareInternationalizationDateFormats.formats[lang];
            var lngDate = moment(this.date, this.pattern).format(format); 
            var dateValid = this.$dealerwareInternationalizationDateFormats.formatPatternRegex[lang].test(lngDate);
            var v;
            
            if(lang === this.$dealerwareInternationalizationDateFormats.FR){
                v = moment(this.date, this.$dealerwareInternationalizationDateFormats.formats['fr'], true).isValid();
            } else {
                v = this.$dealerwareInternationalizationDateFormats.formatPatternRegex[this.lang].test(this.date);   
            }
            
            return v && dateValid;
        }

        public getDisplayDate(d: string) : string {
            if (d && (!this.monthYearOnly && d.match(/^\d{4}\/\d{2}\/\d{2}$/)) || (this.monthYearOnly && d.match(/^\d{2}\/\d{4}$/))) {
                this.setValidity(true);
                return this.monthYearOnly ? d : moment(d).format(this.pattern);
             } else {
                 return d;
             }
        }

        public setValidity(v: boolean) : void {
            var d = moment(this.date, this.pattern);
            var newDate = this.$filter('filterInternationalizationDate')(d);
            var fValidation = this.$dealerwareInternationalizationDateFormats.dateFormatMatch(newDate, this.lang);
            this.$scope.dateInputForm.date.$setValidity('pattern', v);
            if (v) {
                this.$scope.dateInputForm.date.$setValidity('pattern', d.isValid());
            }

            if (v && this.limitDateTo && fValidation && d.isValid()) {
                var now = moment();
                this.$scope.dateInputForm.date.$setValidity('limit', (this.limitDateTo === 'past' && d < now) || (this.limitDateTo === 'future' && d > now));
            } else {
                this.$scope.dateInputForm.date.$setValidity('limit', true);
            }
        }
    }

    getDealerwareWebComponentsModule().controller('DateInputDirectiveController', DateInputDirectiveController);

    export class DateInputDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'DateInputDirectiveController';
        public controllerAs     : string    =   'dateInputController';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public scope            : Object    =   {
            label: '=',
            date: '=',
            monthYearOnly: '@',
            required: '@',
            readOnly: '=',
            limitDateTo: '@',
            onChange: '&'
        };
        public transclude       : boolean   =   false;
        public templateUrl      : string    =   '/components/date_input/date_input_directive.html';
        public static $inject   : string[]  =   [];

        constructor() {}

        public link : ng.IDirectiveLinkFn = (
            scope   :   ng.IScope,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {}
    }

    getDealerwareWebComponentsModule().directive("dealerwareDateInput",() => new DateInputDirective());
 }
